import { atom } from 'recoil';

// User state
export const userAtom = atom({
  key: 'userAtom',
  default: null,
});

// Auth state
export const authState = atom({
  key: 'authState',
  default: {
    isAuthenticated: false,
    token: null,
  },
});

// Loading state
export const loadingState = atom({
  key: 'loadingState',
  default: false,
});

// Course tree state (current/latest)
export const courseTreeAtom = atom({
  key: 'courseTreeAtom',
  default: null,
});

// Course tree baseline (first saved, used as fallback)
export const courseTreeBaselineAtom = atom({
  key: 'courseTreeBaselineAtom',
  default: (() => {
    // Load from localStorage on init
    try {
      const saved = localStorage.getItem('course-tree-baseline');
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  })(),
});

// Lessons by subcourse cache
// Structure: { [subcourseId]: { lessons: [], loading: false, error: null } }
export const lessonsBySubcourseAtom = atom({
  key: 'lessonsBySubcourseAtom',
  default: {},
});

// Skills by lesson cache
// Structure: { [lessonId]: { skills: [], loading: false, error: null } }
export const skillsByLessonAtom = atom({
  key: 'skillsByLessonAtom',
  default: {},
});

// Level state for animation
export const levelStateAtom = atom({
  key: 'levelStateAtom',
  default: {
    currentDisplayLevelForPulse: 0,
    isLevelChanging: false,
    levelChangeDirection: 'none',
  },
});

// User level and XP state
export const userLevelAtom = atom({
  key: 'userLevelAtom',
  default: {
    level: 1.8,
    xp: 0,
    totalXP: 0,
  },
});


// changed by Cursor: audio recordings now store base64 data (survives SPA navigation, no localStorage quota issues)
// Speaking audio recordings state (Recoil - Persists across SPA navigation)
// Structure: { [taskIndex]: { audioUrl: "data:audio/wav;base64,...", soalId: "soal-456" } }
export const speakingAudioRecordingsState = atom({
  key: 'speakingAudioRecordingsState',
  default: {},
});

// Last opened note ID - untuk restore note saat kembali dari Practice
// Structure: { noteId: string, skillId: string, lessonId: string }
export const lastOpenedNoteState = atom({
  key: 'lastOpenedNoteState',
  default: (() => {
    // Load from localStorage on init
    try {
      const saved = localStorage.getItem('lastOpenedNote');
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  })(),
});

// Reported soal state (Recoil - Session only, tidak prevent re-report)
// Structure: Set of report keys: `reported-soal-${type}-${prosetId}-${soalId}`
// Hanya untuk visual feedback, tidak digunakan untuk disable button
export const reportedSoalState = atom({
  key: 'reportedSoalState',
  default: new Set(),
});

// Reported note state (Recoil - Session only)
// Structure: Set of report keys: `reported-note-${noteId}`
// Untuk persist visual state "Reported" saat pindah question di halaman review
export const reportedNoteState = atom({
  key: 'reportedNoteState',
  default: new Set(),
});
